import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment.prod';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
//http://192.168.43.119:8000/api/home
  constructor(private httpClient: HttpClient) {
  }

  getProduct(id:any): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/get_product/${id}`);
  }
  getSimilar(id:any): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/similar/${id}`);
  }
}
